import { render, staticRenderFns } from "./YachtList.vue?vue&type=template&id=095ce2b3&scoped=true&"
import script from "./YachtList.vue?vue&type=script&lang=js&"
export * from "./YachtList.vue?vue&type=script&lang=js&"
import style0 from "./YachtList.vue?vue&type=style&index=0&id=095ce2b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095ce2b3",
  null
  
)

export default component.exports